import styled from 'styled-components';

export default styled.a(({ theme }) => ({
  cursor: 'pointer',
  color: theme.colors.light,
  textDecoration: 'none',
}));
